import microuniversoApi from "app/api/microuniversoApi";
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice";
import store from "app/redux/store/store";
import { DetalhesComissoes } from "app/types/comissoes/Indicadores";
import { WindowMU } from "app/types/WindowMU";

declare var window:WindowMU

export async function detalharComissoesPorIndicador (codigoIndicador: number) {

    const auxDadosIndicador = await microuniversoApi.Orcamento.obterIndicador(store.getState().orcamento.IdentificadorOrcamento, codigoIndicador)

    //const orcamentoLegado = window.orcamentoController.model
    
    store.dispatch(sobrescreverInformacoesAction({Indicador: auxDadosIndicador}))
    //orcamentoLegado.set("Indicador", auxDadosIndicador)

    return auxDadosIndicador;
}

export async function removerIndicador () {
    await microuniversoApi.Orcamento.removerIndicador(store.getState().orcamento.IdentificadorOrcamento)

    //const orcamentoLegado = window.orcamentoController.model

    store.dispatch(sobrescreverInformacoesAction({Indicador: null}))
    //orcamentoLegado.set("Indicador", null)
}

export async function definirIndicador (dadosComissoes: DetalhesComissoes) {

    const auxDadosComissoes = await microuniversoApi.Orcamento.definirIndicador(store.getState().orcamento.IdentificadorOrcamento, dadosComissoes)

    //const orcamentoLegado = window.orcamentoController.model;

    store.dispatch(sobrescreverInformacoesAction({Indicador: auxDadosComissoes}))
    //orcamentoLegado.set("Indicador", auxDadosComissoes)
}

export async function definirPercentualComissaoDiferenciada (valor: number) {

    const auxDadosComissoes = await microuniversoApi.Orcamento.definirPercentualComissaoDiferenciada(store.getState().orcamento.IdentificadorOrcamento, valor)

    //const orcamentoLegado = window.orcamentoController.model;

    store.dispatch(sobrescreverInformacoesAction({Indicador: auxDadosComissoes}))
    //orcamentoLegado.set("Indicador", auxDadosComissoes)
}